import React from 'react';
import { useSelector } from 'react-redux';

import OrderLabelInfo from '../../../common/OrderLabelInfo';
import Panel from '../../../../../components/outline/Panel';
import { ORDER_LIST_SUMMARY_TYPE } from '../../../../../constants/service/app/orderConstants';
import './OrderAllListSummaryBox.scss';

const OrderAllListSummaryBox = () => {
  const { orderSummaryBox } = useSelector((state) => state.order.orderAllList);
  const {
    salesAmount,
    actualSalesAmount,
    usedPointAmount,
    usedCouponAmount,
    createOrderCnt,
    orderItemCancelCnt,
    totalOrderCnt,
    orderItemReturnCnt,
    totalOrderItemCnt,
    orderItemExchangeCnt,
    totalPurchaseQuantity,
  } = orderSummaryBox;

  return (
    <Panel className="order-all-list-summary-box">
      <div className="panel-body">
        <div className="order-all-list-summary-box-info">
          <div className="form-wrap">
            <OrderLabelInfo orderSummaryType={ORDER_LIST_SUMMARY_TYPE.SALES_AMOUNT} info={salesAmount} infoUnit="원" />

            <OrderLabelInfo
              orderSummaryType={ORDER_LIST_SUMMARY_TYPE.ACTUAL_SALES_AMOUNT}
              info={actualSalesAmount}
              infoUnit="원"
            />
          </div>

          <div className="form-wrap">
            <OrderLabelInfo
              orderSummaryType={ORDER_LIST_SUMMARY_TYPE.USED_POINT_AMOUNT}
              info={usedPointAmount}
              infoUnit="원"
            />

            <OrderLabelInfo
              orderSummaryType={ORDER_LIST_SUMMARY_TYPE.USED_COUPON_AMOUNT}
              info={usedCouponAmount}
              infoUnit="원"
            />
          </div>

          <div className="form-wrap">
            <OrderLabelInfo
              orderSummaryType={ORDER_LIST_SUMMARY_TYPE.CREATE_ORDER_CNT}
              info={createOrderCnt}
              infoUnit="건"
            />

            <OrderLabelInfo
              orderSummaryType={ORDER_LIST_SUMMARY_TYPE.ORDER_ITEM_CANCEL_CNT}
              info={orderItemCancelCnt}
              infoUnit="건"
            />
          </div>

          <div className="form-wrap">
            <OrderLabelInfo
              orderSummaryType={ORDER_LIST_SUMMARY_TYPE.TOTAL_ORDER_CNT}
              info={totalOrderCnt}
              infoUnit="건"
            />

            <OrderLabelInfo
              orderSummaryType={ORDER_LIST_SUMMARY_TYPE.ORDER_ITEM_RETURN_CNT}
              info={orderItemReturnCnt}
              infoUnit="건"
            />
          </div>

          <div className="form-wrap">
            <OrderLabelInfo
              orderSummaryType={ORDER_LIST_SUMMARY_TYPE.TOTAL_ORDER_ITEM_CNT}
              info={totalOrderItemCnt}
              infoUnit="건"
            />

            <OrderLabelInfo
              orderSummaryType={ORDER_LIST_SUMMARY_TYPE.ORDER_ITEM_EXCHANGE_CNT}
              info={orderItemExchangeCnt}
              infoUnit="건"
            />
          </div>

          <div className="form-wrap">
            <OrderLabelInfo
              orderSummaryType={ORDER_LIST_SUMMARY_TYPE.TOTAL_PURCHASE_QUANTITY}
              info={totalPurchaseQuantity}
              infoUnit="개"
            />
          </div>
        </div>
      </div>
    </Panel>
  );
};

export default OrderAllListSummaryBox;
